
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qmee/cashbacks/[offerGuid]",
      function () {
        return require("private-next-pages/qmee/cashbacks/[offerGuid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qmee/cashbacks/[offerGuid]"])
      });
    }
  